var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6451 20.9012C22.4973 20.9124 21.734 20.958 20.0314 20.958C18.6772 20.958 17.7157 20.9173 17.3783 20.9012C12.1448 20.6705 8.23851 19.7576 8.23851 18.6645C8.23851 17.5714 12.1448 16.6596 17.3783 16.4252V19.992C17.7206 20.0167 18.7006 20.0746 20.0548 20.0746C21.6799 20.0746 22.4936 20.0068 22.6401 19.9932V16.4277C27.8625 16.6609 31.7603 17.5738 31.7603 18.6645C31.7603 19.7551 27.8638 20.6681 22.6401 20.9L22.6451 20.9012ZM22.6451 16.0588V12.8671H29.9333V8H10.0901V12.8671H17.3771V16.0576C11.4542 16.3302 7 17.506 7 18.9149C7 20.3239 11.4542 21.4984 17.3771 21.7723V32H22.6438V21.7686C28.5532 21.4959 33 20.3214 33 18.9137C33 17.506 28.5569 16.3315 22.6438 16.0576L22.6451 16.0588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.3476f8c172d2b9f1a2ad23687208d361.svg";
export { ForwardRef as ReactComponent };